/**
 * Unified Google Maps Theme for NAVEGA
 * 
 * This is the single source of truth for map styling across the entire application.
 * - Keeps Google's default land/road colors for familiarity
 * - Hides business POIs and transit icons to reduce visual noise
 * - Applies consistent water color (#a4ddf5) across all maps
 * 
 * Usage:
 *   import { mapStyles } from '../../utils/mapTheme';
 *   <GoogleMap options={{ styles: mapStyles }} />
 */

export const mapStyles = [
  {
    "featureType": "poi",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "transit",
    "elementType": "labels.icon",
    "stylers": [{ "visibility": "off" }]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [{ "color": "#a4ddf5" }]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [{ "color": "#9e9e9e" }]
  }
];

export default mapStyles;
